import React from 'react';
import { navigate } from 'gatsby';
import { getIssuePath, getPostPath } from '../../../model/post';

const IssueNav = ({ issue, idx, toggleNavList }) => {
  const { slug, tghpwipIssuesTaxonomyCategory: type, posts } = issue;

  const handleIssueClick = () => {
    const listedIssues = document.querySelectorAll('.issue-section');

    if (listedIssues.length > 0) {
      listedIssues[idx].scrollIntoView();
    } else {
      if (type === 'film') {
        if (posts?.nodes.length > 0) {
          navigate(getPostPath(posts.nodes[0].slug));
        }
      } else {
        navigate(getIssuePath(slug));
      }
    }

    toggleNavList();
  };

  return (
    <li>
      <button onClick={handleIssueClick}>{issue.name}</button>
    </li>
  );
};

export default IssueNav;
